import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ThankYou() {
  // Scroll to top on mount so the confirmation is the first thing visitors see.
  useEffect(() => {
    window.scrollTo(0, 0);
    // The Meta Pixel (once installed) fires a PageView automatically when this
    // page loads. Create a "Lead" conversion in Meta Events Manager using a URL
    // rule that matches /thank_you to track every completed quote request.
  }, []);
  return <div className="min-h-screen bg-white font-sans text-black overflow-x-hidden flex flex-col" data-id="element-184">
      <Header data-id="element-185" />
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-24" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="max-w-xl mx-auto text-center" data-id="element-187">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 15,
          delay: 0.1
        }} data-id="element-188">
            <CheckCircleIcon className="w-24 h-24 mx-auto mb-8 text-black" strokeWidth={1.5} data-id="element-189" />
          </motion.div>
          <h1 className="text-4xl md:text-6xl font-black uppercase mb-6 leading-[1.1]" data-id="element-190">
            Quote Request Sent!
          </h1>
          <p className="text-xl text-gray-600 font-medium mb-10" data-id="element-191">
            Thank you! We received your request and we’ll get back to you fast
            during business hours. Check your email for a confirmation.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-192">
            <Link to="/" className="w-full sm:w-auto bg-black text-white px-10 py-4 font-display font-black uppercase tracking-widest text-lg hover:bg-neutral-800 transition-colors" data-id="element-193">
              Back to Home
            </Link>
            <a href="https://wa.me/18582542524?text=Hi%2C%20I%20just%20requested%20a%20quote.%20Can%20we%20chat%3F" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-[#25D366] text-white px-10 py-4 font-display font-black uppercase tracking-widest text-lg hover:bg-[#1fb855] transition-colors flex items-center justify-center gap-3" data-id="element-194">
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" data-id="element-195">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-196" />
              </svg>
              Message Us on WhatsApp
            </a>
          </div>
        </motion.div>
      </main>
      <Footer data-id="element-197" />
    </div>;
}